module.exports = __webpack_public_path__ + "media/bootstrap-icons/square-375622e9.svg";